import { AAMode, proxyBase, setDirect, setProxy } from '../../modules/config';
import { Button, CircularProgress, Container, Dialog, ExpansionPanel, ExpansionPanelActions, ExpansionPanelDetails, ExpansionPanelSummary, FormControlLabel, Link as MuiLink, Radio, RadioGroup, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import { Link, RouteComponentProps } from 'react-router-dom';
import React, { ChangeEvent, Component, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkProps } from '@material-ui/core/Link';
import { List } from 'immutable';
import { bindActionCreators } from 'redux';
import { clearRecords } from '../../modules/tracelog';
import { connect } from 'react-redux';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { push } from 'connected-react-router';

const Websocket: any = require('react-websocket')

const styles = (theme: Theme) => createStyles({
  root: {
    width: '100%',
    margin: `${theme.spacing(8)}px 0`
  },
  title: {
    marginBottom: theme.spacing(4),
    textAlign: 'center'
  },
  heading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  primaryHeading: {
    flexBasis: "33.33%",
    flexShrink: 0,
    verticalAlign: 'middle',
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
    lineHeight: 'normal',
    verticalAlign: 'middle',
  },
  proxiesWaiting: {
    textAlign: 'center',
  },
  proxiesWaitingProgress: {
    marginRight: theme.spacing(1),
  },
  details: {
    flexDirection: 'column'
  }
});

type State = {
  proxies: List<string>
  redirect: string
  loading: boolean
  mode: AAMode
  proxyId: string
  endpoint: string
  callerId: string
  callerCredential: string
  modalDownloadProxy: boolean
}

class ProxySelector extends Component<Props, State> {
  state: State = {
    proxies: List<string>(),
    redirect: "",
    loading: true,
    mode: null,
    proxyId: "",
    endpoint: "",
    callerId: "",
    callerCredential: "",
    modalDownloadProxy: false
  }

  refWebsocket = React.createRef<typeof Websocket>()

  componentDidMount = () => {
    const { config } = this.props
    this.setState({
      mode: config.aa.mode,
      endpoint: config.aa.endpoint,
      callerId: config.aa.callerId,
      callerCredential: config.aa.callerCredential
    })
  }

  handleMessage = (rawData: any) => {
    let data = JSON.parse(rawData)
    if (data.type)
      switch (data.type) {
        case "list":
          if (data.list) {
            let proxies = List<string>(data.list as string[])
            this.setState({ proxies, loading: false })
          }
          break
      }
  }

  handleClick = (p: string) => (e: React.MouseEvent) => {
    const { setProxy } = this.props
    setProxy(p)
    e.preventDefault()
  }

  getProxyUrl = (p: string) => {
    const { match } = this.props
    return match.url + "proxy/" + p
  }

  getOS = () => {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  handleModeChange = (value: string) => () => {
    this.setState({
      mode: (value === this.state.mode ? null : value as AAMode)
    })
  }

  handleProxyChange = (_: ChangeEvent<{}>, proxyId: string) => {
    this.setState({
      proxyId
    })
  }

  handleProxyConnect = () => {
    const { config, push, proxyBase, setProxy, clearRecords } = this.props
    if (!this.state.proxyId)
      return
    if (config.aa.mode !== "proxy" || config.aa.proxyId !== this.state.proxyId) {
      setProxy(this.state.proxyId)
      clearRecords()
    }
    push(proxyBase())
  }

  handleInputChange = (path: "endpoint" | "callerId" | "callerCredential") => (e: ChangeEvent<HTMLInputElement>) => {
    let v = e.target.value
    this.setState({
      ...this.state,
      [path]: v
    })
  }

  handleDownloadProxyDialog = (state: boolean) => () => {
    this.setState({
      modalDownloadProxy: state
    })
  }

  getDownloadUrl = (platform: string) =>
    "https://static.demobank.seanl.im/dbc-proxy-" + platform

  renderDownloads = () => {
    let downloads: { os: string, bit32: string, bit64: string }[] = [
      {
        os: 'Windows',
        bit32: 'windows-386.exe',
        bit64: 'windows-amd64.exe',
      },
      {
        os: 'Linux',
        bit32: 'linux-386',
        bit64: 'linux-amd64',
      },
      {
        os: 'MacOS',
        bit32: 'darwin-386',
        bit64: 'darwin-amd64'
      }
    ]

    return downloads.map((d, i) => (
      <TableRow key={i}>
        <TableCell>{d.os}</TableCell>
        <TableCell><MuiLink href={this.getDownloadUrl(d.bit32)}>{d.bit32}</MuiLink></TableCell>
        <TableCell><MuiLink href={this.getDownloadUrl(d.bit64)}>{d.bit64}</MuiLink></TableCell>
      </TableRow>
    ))
  }

  connectDirect = () => {
    this.props.setDirect(this.state.endpoint, this.state.callerId, this.state.callerCredential)
    this.props.push('/direct')
  }

  render() {
    const { proxies, mode, loading, proxyId, modalDownloadProxy } = this.state
    const { classes } = this.props

    return (
      <Container maxWidth="sm">
        <Websocket url={window.location.protocol.replace('http', 'ws') + "//" + window.location.host + "/ws/proxies"} onMessage={this.handleMessage} ref={(ws: React.RefObject<typeof Websocket>) => this.refWebsocket = ws} />
        <div className={classes.root}>
          <Typography variant="h4" className={classes.title}>Demo Mode</Typography>

          <ExpansionPanel expanded={mode === 'proxy'} onChange={this.handleModeChange('proxy')}>
            <ExpansionPanelSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth />} classes={{ content: classes.heading }}>
              <Typography className={classes.primaryHeading}>Proxy</Typography>
              <div className={classes.secondaryHeading}>Integrate with AA via a proxy</div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.details}>
              {loading
                ? <CircularProgress />
                : proxies.size === 0
                  ? <div className={classes.proxiesWaiting}>
                    <CircularProgress className={classes.proxiesWaitingProgress} size={20} />
                    <Typography variant="caption">Waiting for proxies to connect...</Typography>
                  </div>
                  : <Fragment>
                    <Typography variant="body2">Select a proxy to connect to:</Typography>
                    <RadioGroup value={proxyId} onChange={this.handleProxyChange}>
                      {proxies.map((proxy, i) => (
                        <FormControlLabel key={i} value={proxy} control={<Radio color="primary" />} label={proxy} />
                      ))
                      }
                    </RadioGroup>
                  </Fragment>
              }
            </ExpansionPanelDetails>
            <ExpansionPanelActions>
              <Button size="small" onClick={this.handleDownloadProxyDialog(true)}>Download Proxy</Button>
              <Button onClick={this.handleProxyConnect} size="small" color="primary" disabled={!Boolean(proxyId)}>
                Connect
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
          <Dialog onClose={this.handleDownloadProxyDialog(false)} open={modalDownloadProxy}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>OS</TableCell>
                  <TableCell>32-bit</TableCell>
                  <TableCell>64-bit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.renderDownloads()}
              </TableBody>
            </Table>
          </Dialog>
          <ExpansionPanel expanded={mode === 'direct'} onChange={this.handleModeChange('direct')}>
            <ExpansionPanelSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth />} classes={{ content: classes.heading }}>
              <Typography className={classes.primaryHeading}>Direct</Typography>
              <Typography className={classes.secondaryHeading}>Connect to AA directly</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: '100%' }}>
                <div>
                  <TextField margin="normal" label="SOAP Endpoint" value={this.state.endpoint} onChange={this.handleInputChange('endpoint')} fullWidth />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <TextField style={{ flex: '1 1 auto' }} margin="normal" label="SOAP Caller ID" value={this.state.callerId} onChange={this.handleInputChange('callerId')} />
                  <TextField style={{ flex: '1 1 auto' }} margin="normal" label="SOAP Caller Credential" value={this.state.callerCredential} onChange={this.handleInputChange('callerCredential')} />
                </div>
              </div>
            </ExpansionPanelDetails>
            <ExpansionPanelActions>
              <Button onClick={this.connectDirect} size="small" color="primary">
                Connect
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
          <ExpansionPanel expanded={mode === 'bypass'} onChange={this.handleModeChange('bypass')}>
            <ExpansionPanelSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth />} classes={{ content: classes.heading }}>
              <Typography className={classes.primaryHeading}>Bypass</Typography>
              <Typography className={classes.secondaryHeading}>No AA integration</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography>
                Note: Features dependent on AA will not be available
              </Typography>
            </ExpansionPanelDetails>
            <ExpansionPanelActions>
              {/* https://github.com/mui-org/material-ui/issues/15171 */}
              <Button component={React.forwardRef<HTMLAnchorElement, Partial<LinkProps>>((props, ref) => <Link {...props} to="/bypass" ref={ref as any} />)} size="small" color="primary">
                Connect
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </div>
      </Container>
    )
  }
}

const mapStateToProps = ({ config }: IStoreState) => ({
  config
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      setProxy,
      setDirect,
      proxyBase,
      push,
      clearRecords,
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProxySelector));